import React, { Component } from "react";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { Provider, connect } from "react-redux";
import reducer from "../../reducers/top/my_circle_list";
import saga from "../../sagas/top/my_circle_list";
import actionCreators from "../../actions/top/my_circle_list";

import Loader from "../../components/loader";
import MyCircle from "../../components/top/my_circle";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class MyCircleList extends Component {
  UNSAFE_componentWillMount() {
    store.dispatch(actionCreators.top.mycircles.set());
  }
  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

const TmpRoot = ({ state }) => {
  if (state.loading) {
    return <Loader isActive={state.loading} />;
  }
  if (state.myCircles.length == 0) return <div />;
  const circles = state.myCircles.map(function(circle) {
    return (
      <MyCircle circle={circle.circle} isMyCircleUri={true} key={circle.id} />
    );
  });
  return (
    <div>
      <article className="timeline-box mb10">
        <h2 className="left">
          <i className="fas fa-users icon_blue" aria-hidden="true" />&nbsp;マイサークル
        </h2>
        <div className="touch-wrap">
          <div className="touch">{circles}</div>
        </div>
      </article>
    </div>
  );
};

const mapStateToProps = (state) => ({
  state,
});

const Root = connect(mapStateToProps)(TmpRoot);
